import { getCountryCurrencyCode } from './currency';

export const getCurrencyWallet = (userWallet) => {
  return userWallet.find(
    (wallet) => wallet.currency === getCountryCurrencyCode(),
  );
};
